<template>
  <div>
    <div
        v-if="adMobLoading"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>

    <v-container class="padding_10" fluid grid-list-md v-else>
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg12>
          <v-card>
            <v-flex xm12 sm12 md12 lg12 style="display: flex;">
              <v-flex xs12 sm12 md3 lg3>
                <v-card-title class="headline">Issue details</v-card-title>
              </v-flex>

              <v-flex xs12 sm12 md9 lg9 style="display: flex; align-items: center;justify-content: flex-end;flex-wrap: wrap;">
                <v-flex xs12 sm12 md2 lg2></v-flex>
                <v-flex xs12 sm12 md4 lg4 style="display: flex; justify-content: flex-end;"
                        v-if="(issue_details.order_sub_category == 'ORD101' ||
                        issue_details.order_sub_category == 'FLM101' ||
                        issue_details.order_sub_category == 'FLM102' ||
                        issue_details.order_sub_category == 'FLM103' ||
                        issue_details.order_sub_category == 'FLM104')">
                  <v-btn color="cyan" @click="raisedToSellerDialog = true"
                         :disabled="(issue_details.issue_status == 'CLOSE' &&
                         issue_details.issue_action == 'RESOLVED') ||
                         issue_details.issue_action == 'RESOLVED' ||
                         (issue_details.issue_action == 'PROCESSING' && issue_details.raised_to_seller == 1)">
                    <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                    Raised to seller({{issue_details.raised_to_seller}})
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm12 md3 lg3 style="display: flex; justify-content: flex-end;"
                        v-if="(issue_details.order_sub_category == 'ORD101' ||
                        issue_details.order_sub_category == 'PMT101' ||
                        issue_details.order_sub_category == 'PMT102' ||
                        issue_details.order_sub_category == 'OTH01' ||
                        issue_details.order_sub_category == 'FLM101' ||
                        issue_details.order_sub_category == 'FLM102' ||
                        issue_details.order_sub_category == 'FLM103' ||
                        issue_details.order_sub_category == 'FLM104')">
                  <v-btn color="warning" @click="resolvedIssueDialog = true"
                         :disabled="issue_details.issue_action == 'RESOLVED' ||
                         issue_details.issue_status == 'CLOSE'">
                    <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                    Set Resolved
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm12 md3 lg3 style="display: flex; justify-content: flex-end;"
                        v-if="(issue_details.order_sub_category == 'ORD101' ||
                        issue_details.order_sub_category == 'PMT101' ||
                        issue_details.order_sub_category == 'PMT102' ||
                        issue_details.order_sub_category == 'OTH01') && issue_details.raised_to_seller == 0">
                  <v-btn color="error" @click="closeIssueDialog = true"
                         :disabled="issue_details.issue_status == 'CLOSE'">
                    <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                    Close Issue
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm12 md3 lg3 style="display: flex; justify-content: flex-end;"
                        v-else-if="((issue_details.order_sub_category == 'ORD101' ||
                        issue_details.order_sub_category == 'PMT101' ||
                        issue_details.order_sub_category == 'FLM101' ||
                        issue_details.order_sub_category == 'FLM102' ||
                        issue_details.order_sub_category == 'FLM103' ||
                        issue_details.order_sub_category == 'FLM104') && issue_details.raised_to_seller == 1)">
                  <v-btn color="error" @click="closeSellerSideIssueDialog = true"
                         :disabled="issue_details.issue_status == 'CLOSE'">
                    <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                    Close Issue
                  </v-btn>
                </v-flex>
              </v-flex>


            </v-flex>

            <v-flex xs12 sm12 md12 lg12
                    style="display: flex;align-items: center;flex-direction: row;flex-wrap: wrap;">

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Source Station:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                    <v-text-field box disabled=""
                        v-model="issue_details.start_station_name"
                    ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>End Station:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                      v-model="issue_details.end_station_name"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Journey Type:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                v-model="issue_details.journey_type"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Date:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                v-model="issue_details.date"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Provider:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                :value="issue_details.provider_name"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Quantity & Price:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                :value="concatenatedPrice"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Ticket & Payment Status:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                :value="concatenatedStatus"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Order Category / Sub:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                v-model="concatenatedOrderCategory"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Issue Status:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-text-field box disabled
                                v-model="issue_details.issue_status"
                  ></v-text-field>
                </v-flex>
              </v-flex>



              <v-flex xs12 sm12 md8 lg8 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Issue Message:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex">
                  <v-textarea box disabled auto-grow rows="2"
                              v-model="issue_details.long_description"
                  ></v-textarea>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg4 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Issue Action:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex;">
                  <v-text-field box disabled
                                v-model="issue_details.issue_action"
                  ></v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md8 lg8 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Respondent Action:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex;">
                  <v-textarea box disabled auto-grow rows="2"
                                v-model="issue_details.resolution_long_desc"
                  ></v-textarea>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg8 style="display: flex; align-items: center;">
                <v-flex xs12 sm12 md3 lg3>
                  <v-label>Respond Org:</v-label>
                </v-flex>
                <v-flex xs12 sm12 md9 lg9 style="display: flex;">
                  <v-text-field box disabled
                                v-model="issue_details.respondent_org"
                  ></v-text-field>
                </v-flex>
              </v-flex>

            </v-flex>

          </v-card>
        </v-flex>
      </v-layout>


      <v-dialog v-model="resolvedIssueDialog" max-width="700px" style="margin-top: -30px;margin-right: -31px;">
        <v-card>
          <v-form id="resolvedIssueDialog"
                  @submit.prevent="validateBeforeSubmit('resolvedIssueDialog')"
                  data-vv-scope="resolvedIssueDialog"
                  ref="update_resolved_form"
                  v-model="resolvedIssue">

            <v-card-title style="padding-bottom: 0px;">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <h4 class="heading_text">Update Issue to Resolved</h4>
                <v-btn icon @click="resolvedIssueDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 style="display: flex; align-items: center;">
                  <v-flex xs4 sm4 md3 lg3>
                    <label>Resolution Short Desc: </label>
                  </v-flex>

                  <v-flex xs8 sm8 md9 lg9>
                    <v-text-field
                        label="Short desc" box clearable
                        v-model="resolved_issue.resolution_short_desc"></v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex; align-items: center;">
                  <v-flex xs4 sm4 md3 lg3>
                    <label>Resolution Detailed Desc: </label>
                  </v-flex>

                  <v-flex xs8 sm8 md9 lg9>
                    <v-textarea clearable
                        label="Detailed desc" box auto-grow rows="4"
                        v-model="resolved_issue.resolution_long_desc"></v-textarea>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="danger" type="reset" small @click="resolvedIssueDialog = false;
              loaders.resolved_loader = false">
                Cancel
              </v-btn>
              <v-btn :loading="loaders.resolved_loader" :disabled="loaders.resolved_loader ||
                (resolved_issue.resolution_long_desc == '' || resolved_issue.resolution_short_desc == '')"
                     color="primary" small @click="updateIssueStatus('RESOLVED')">Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="raisedToSellerDialog" max-width="700px">
        <v-card>
          <v-form id="raisedToSellerDialog"
                  @submit.prevent="validateBeforeSubmit('raisedToSellerDialog')"
                  data-vv-scope="raisedToSellerDialog"
                  ref="raised_to_seller_form"
                  v-model="raisedToSeller">
            <v-card-title style="padding-bottom: 0px;">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <h2 class="heading_text">Raise Issue to Seller(L1)</h2>
                <v-btn icon @click="resolvedIssueDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text style="padding-bottom: 40px;">
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to raised this issue to respective seller?</h3>
                </v-flex>
              </v-layout>
              <v-spacer></v-spacer>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat type="reset" color="danger" small @click="raisedToSellerDialog = false;
              loaders.issueRaised_loader =
              false">
                Cancel
              </v-btn>
              <v-btn :loading="loaders.issueRaised_loader" :disabled="loaders.issueRaised_loader"
                     color="primary" small @click="updateIssueStatus('RAISED')">Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="closeIssueDialog" max-width="700px">
        <v-card>
          <v-form id="closeIssueDialog"
                  @submit.prevent="validateBeforeSubmit('closeIssueDialog')"
                  data-vv-scope="closeIssueDialog"
                  ref="close_form"
                  v-model="closeIssue">
            <v-card-title style="padding-bottom: 0px;">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <h2 class="heading_text">Close Issue</h2>
                <v-btn icon @click="closeIssueDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text style="padding-bottom: 40px;">
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to close this issue ?</h3>
                </v-flex>
              </v-layout>
              <v-spacer></v-spacer>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat type="reset" color="danger" small @click="closeIssueDialog = false;
              loaders.closeIssue_loader = false">
                Cancel
              </v-btn>
              <v-btn :loading="loaders.closeIssue_loader" :disabled="loaders.closeIssue_loader"
                     color="primary" small @click="updateIssueStatus('CLOSE')">Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="closeSellerSideIssueDialog" max-width="700px">
        <v-card>
          <v-form id="closeSellerSideIssueDialog"
                  @submit.prevent="validateBeforeSubmit('closeSellerSideIssueDialog')"
                  data-vv-scope="closeSellerSideIssueDialog"
                  ref="close_form"
                  v-model="closeIssue">
            <v-card-title style="padding-bottom: 0px;">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <h2 class="heading_text">Close Issue</h2>
                <v-btn icon @click="closeSellerSideIssueDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text style="padding-bottom: 40px;">
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to close this issue ?</h3>
                </v-flex>
              </v-layout>
              <v-spacer></v-spacer>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat type="reset" color="danger" small @click="closeSellerSideIssueDialog = false;
              loaders.closeIssue_loader = false">
                Cancel
              </v-btn>
              <v-btn :loading="loaders.closeIssue_loader" :disabled="loaders.closeIssue_loader"
                     color="primary" small @click="closeSellerIssueStatus('CLOSE')">Confirm
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>



      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
</div>
</template>

<script>
export default {
  name: "Detail",
  watch:{

  },
  data(){
    return{
      adMobLoading: false,
      issue_details: [],
      resolvedIssue: '',
      closeIssue: '',
      resolved_issue: {
        issue_id: '',
        transaction_id: '',
        resolution_short_desc: '',
        resolution_long_desc: '',
        // resolution_action_triggered: ''
      },
      raisedToSeller: "",
      raised_to_seller:{
        issue_id: '',
        transaction_id: '',
        actual_issue_status: ''
      },
      closeRequest:{
        issue_id: '',
        transaction_id: '',
        actual_issue_status: ''
      },
      resolvedIssueDialog: false,
      raisedToSellerDialog: false,
      closeIssueDialog: false,
      closeSellerSideIssueDialog: false,
      closeSellerSideRequest: {
        transaction_id: '',
        order_category: '',
        order_sub_category: '',
        long_description: '',
        issue_status: "CLOSE"
      },
      loaders: {
        issue_loader: false,
        resolved_loader: false,
        closeIssue_loader: false,
        issueRaised_loader: false
      },
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
    }
  },
  computed: {
    concatenatedPrice() {
      return this.issue_details.quantity + " / Rs. " + this.issue_details.price;
    },
    concatenatedStatus() {
      return this.issue_details.ticket_status + " / " + this.issue_details.payment_status;
    },
    concatenatedOrderCategory() {
      return this.issue_details.order_category + " / " + this.issue_details.order_sub_category;
    }
  },
  methods: {
    getIssueDetails() {
      this.startLoading();
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/fetch-issue-details-web`,
          {headers: this.$headers, params: {transaction_id: this.$route.params.id}}).then((response) => {
        if (response.data.status == 1) {
          this.issue_details = response.data.data[0];
          this.resolved_issue.issue_id = this.issue_details.id;
          this.stopLoading();
        } else if(response.data.status == 0)  {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      });
    },
    updateIssueStatus(type){
      this.startLoading();
      let passData = {};

      if (type === 'RESOLVED') {
        this.resolved_issue.issue_id = this.issue_details.id;
        this.resolved_issue.transaction_id = this.issue_details.transaction_id;
        this.resolved_issue.actual_issue_status = this.issue_details.issue_status;
        passData = this.resolved_issue;
      }else if(type == 'RAISED'){
        this.raised_to_seller.issue_id = this.issue_details.id;
        this.raised_to_seller.transaction_id = this.issue_details.transaction_id;
        this.raised_to_seller.actual_issue_status = this.issue_details.issue_status;
        passData = this.raised_to_seller;
      }else if(type == 'CLOSE'){
        this.closeRequest.issue_id = this.issue_details.id;
        this.closeRequest.transaction_id = this.issue_details.transaction_id;
        this.closeRequest.actual_issue_status = this.issue_details.issue_status;
        passData = this.closeRequest;
      }
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-issue-status`, {
        issue_status: type,data: passData}).then((response) => {
        if (response.data.status == 1) {
          this.getIssueDetails();
          this.resolvedIssueDialog = false;
          this.raisedToSellerDialog = false;
          this.resolved_issue.resolution_short_desc = '';
          this.resolved_issue.resolution_long_desc = "";
          this.closeIssueDialog = false;
          this.getIssueDetails();
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          // this.issue_details = response.data.data[0];
        } else if(response.data.status == 0) {
          this.getIssueDetails();
          this.stopLoading();
          this.resolved_issue.resolution_short_desc = '';
          this.resolved_issue.resolution_long_desc = "";
          this.resolvedIssueDialog = false;
          this.raisedToSellerDialog = false;
          this.closeIssueDialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.stopLoading();
        this.resolvedIssueDialog = false;
        this.raisedToSellerDialog = false;
        this.resolved_issue.resolution_short_desc = '';
        this.resolved_issue.resolution_long_desc = "";
        this.closeIssueDialog = false;
        this.snackbar.message = "Something went wrong";
        this.snackbar.display = true;
      });
    },
    closeSellerIssueStatus(type) {
      this.startLoading();
      let passData = {};

      if(type == 'CLOSE'){
        this.closeSellerSideRequest.issue_id = this.issue_details.id;
        this.closeSellerSideRequest.order_category = this.issue_details.order_category;
        this.closeSellerSideRequest.order_sub_category = this.issue_details.order_sub_category;
        this.closeSellerSideRequest.transaction_id = this.issue_details.transaction_id;
        this.closeSellerSideRequest.actual_issue_status = this.issue_details.issue_status;

        passData = this.closeSellerSideRequest;
      }
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/clsoe-seller-side-issue`, {
        issue_status: type,data: passData},).then((response) => {
        if (response.data.status == 1) {
          this.getIssueDetails();
          this.closeSellerSideIssueDialog = false;
          this.getIssueDetails();
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
          // this.issue_details = response.data.data[0];
        } else if(response.data.status == 0) {
          this.getIssueDetails();
          this.stopLoading();
          this.closeSellerSideIssueDialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.stopLoading();
        this.closeSellerSideIssueDialog = false;
        this.snackbar.message = "Something went wrong";
        this.snackbar.display = true;
      })
    }
    },
  mounted() {
    this.getIssueDetails();
  }
}
</script>

<style scoped>

</style>
